import { render, staticRenderFns } from "./DynamicTradeCriteria.vue?vue&type=template&id=1bf0971e&"
import script from "./DynamicTradeCriteria.vue?vue&type=script&lang=js&"
export * from "./DynamicTradeCriteria.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTradeCriteria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VIcon,VSpacer})
